<script setup>
import { defineProps } from 'vue'
import {UseMoneyStore} from "@/stores/moneyStore";
import {useI18n} from "vue-i18n";

const moneyStore = UseMoneyStore();
const {t} = useI18n();
defineProps({
  refundMethod: {
    type: Object,
    required: true
  }
})

</script>

<template>
  <div class="mb-6">
    <label class="flex items-center">
      <input
          type="radio"
          name="how"
          id="credit"
          :value="refundMethod.key"
          v-model="moneyStore.selectedHowReturnMoney"
          class="accent-bw-black mr-2"
      />
      <span class="block">{{ t('storeCredit.title') }}</span>
    </label>
    <span class="ml-5 text-bw-lightDarkGrey italic responsive-body-xsmall block" v-html="t('storeCredit.description')">
    </span>
  </div>
</template>

